"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onSendReferralData = exports.onInitialization = exports.onRemoveReferral = exports.onAddReferral = exports.setError = exports.clearReferrals = exports.removeReferral = exports.addReferral = exports.NOOP = void 0;
const provider_components_1 = require("@kyruus/provider-components");
const xstate_1 = require("xstate");
const util_1 = require("../common/util");
const constants_1 = require("../common/constants");
/**
 * A function that results in no operation.
 */
const NOOP = () => {
    /* No-op */
};
exports.NOOP = NOOP;
exports.addReferral = (0, xstate_1.assign)({
    referrals: (ctx, ev) => {
        (0, util_1.assertEventType)(ev, constants_1.ReferralEvents.ADD_REFERRAL);
        const referredProvider = ev.data;
        const { referrals } = ctx;
        const providerIdx = referrals.findIndex(({ provider, location }) => provider.id === referredProvider.provider.id &&
            (location === null || location === void 0 ? void 0 : location.id) === referredProvider.location.id);
        if (providerIdx === -1) {
            return [
                ...referrals,
                Object.assign(Object.assign({}, referredProvider), { status: provider_components_1.ProviderStatus.REFERRED })
            ];
        }
        return referrals;
    }
});
exports.removeReferral = (0, xstate_1.assign)({
    referrals: (ctx, ev) => {
        (0, util_1.assertEventType)(ev, constants_1.ReferralEvents.REMOVE_REFERRAL);
        const referredProvider = ev.data;
        const { referrals } = ctx;
        const providerIdx = referrals.findIndex(({ provider, location }) => provider.id === referredProvider.provider.id &&
            (location === null || location === void 0 ? void 0 : location.id) === referredProvider.location.id);
        if (providerIdx === -1) {
            return referrals;
        }
        return [
            ...referrals.slice(0, providerIdx),
            ...referrals.slice(providerIdx + 1)
        ];
    }
});
exports.clearReferrals = (0, xstate_1.assign)({
    referrals: (_, ev) => {
        (0, util_1.assertEventType)(ev, constants_1.ReferralEvents.DONE_INVOKE_SEND_REFERRAL_DATA);
        return [];
    }
});
/**
 * an action to set referral errors in context
 */
exports.setError = (0, xstate_1.assign)({
// Empty stub to add error handling for referrals when needed
});
/*
 * Action handlers that can be overridden by the consumer.
 * Each handler executes as part of the specified action.
 * E.g. `onAddReferral` executes when the `addReferral` action is triggered.
 */
exports.onAddReferral = exports.NOOP;
exports.onRemoveReferral = exports.NOOP;
exports.onInitialization = exports.NOOP;
exports.onSendReferralData = exports.NOOP;
//# sourceMappingURL=actions.js.map